import type { TAllowedModule, TPermissionModule } from 'entities/workspace'

import { ALLOWED_MODULE_TO_PERMISSION_MODULE } from './allowed-modules.consts'

export const mapAllowedModulesToPermissionModules = (allowedModules: TAllowedModule[]): TPermissionModule[] =>
  allowedModules
    .map(module => ALLOWED_MODULE_TO_PERMISSION_MODULE[module])
    .filter((module): module is TPermissionModule => Boolean(module))
